import { Button } from "primereact/button";
import { url } from "@/Helpers/general";
import BaseTextInput from "@/Components/Forms/Form/BaseTextInput";
import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useUpdateSearchParams } from "@/Hooks/useUpdateSearchParams";
import { useMemo, useState } from "react";
import { useDebounce } from "react-use";
import useGetTeamsFiltersQuery, { TeamFilterType } from "@/Hooks/useGetTeamsFiltersQuery";
import TeamsDatatable from "@/Components/Datatables/TeamsDatatable";


const StyledWrap = styled.main`
    .content-container {
        margin-top: 2rem;
    }

    .page-actions {
        margin-top: 2rem;
        padding: 1rem;
        background: #fff;
        border-radius: 8px;
    }
`;


const TeamsPage = () => {
    const navigate = useNavigate();
    const updateUsersFilterHandler = useUpdateSearchParams();
    const {
        searchQuery
    } = useGetTeamsFiltersQuery();

    const [inputValue, setInputValue] = useState(searchQuery || '');


    useDebounce(
        () => {
            updateUsersFilterHandler(TeamFilterType.Search, inputValue);
        },
        1000,
        [inputValue]
    );
    

    const requestParams = useMemo(() => {
        return {
            search: searchQuery || undefined
        };
    }, [searchQuery]);

    return (
        <PageLayout>
            <StyledWrap>
                <div className="flex justify-content-between content-header">
                    <div>
                        <h2 className="content-header__title">Teams</h2>
                    </div>
                    <Button onClick={() => navigate(url('create-team'))}>Create New Team</Button>
                </div>
                <div className="flex align-items-end gap-3">
                    <BaseTextInput
                        value={inputValue || ''}
                        placeholder="Search"
                        onChange={(e) => {
                            setInputValue(e.target.value);
                        }}
                    />
                </div>
                <div className="content-container">
                    <TeamsDatatable requestParams={requestParams}/>
                </div>
            </StyledWrap>
        </PageLayout>
    );
};

export default TeamsPage;